import styled from "@emotion/styled";
import { Content } from "src/atoms/Content";

const StyledLogoHeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
`;

const StyledLogoHeader = styled(Content)`
  padding: 48px 20px 0;
  text-align: right;
  width: 100%;

  svg {
    width: 136px;
  }

  path {
    fill: ${({ theme }) => theme.colors.tone.white};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    text-align: center;
    padding: 24px 20px 0;

    svg {
      width: 104px;
    }
  }
`;

export { StyledLogoHeaderWrapper, StyledLogoHeader };
